<div class="is-flex is-centered">
    <span class="icon is-huge is-warning">
        <i class="tri-alert" aria-hidden="true"></i>
    </span>
</div>
<div style="margin-top: 24px"></div>
<p class="text is-level-1">
    L'appareil que vous avez ajouté au panier ne permet pas d'utiliser une {{ type === SIM_TYPES.QRESIM ? 'carte SIM' : 'eSIM' }}.
    <br />
    <b>Nous vous conseillons de choisir une {{ type === SIM_TYPES.QRESIM ? 'eSIM' : 'carte SIM physique' }}.</b>
</p>
<p class="text is-level-1">
    Si vous choisissez une eSIM maintenant, vous devrez l’utiliser avec un autre appareil.
</p>

<ng-template #customModalFooter>
    <div class="buttons">
        <button
            data-tc-action="Clic_selection"
            attr.data-tc-categorie="{{
                type === SIM_TYPES.QRESIM ? 'Modale_incompatibilite_eSIM' : 'Modale_incompatibilite_carte_SIM'
            }} "
            attr.data-tc-clic="{{ type === SIM_TYPES.QRESIM ? 'Passer_a_une_carte_SIM' : 'Passer_a_une_eSIM' }}"
            (click)="confirmChoice(false)"
            class="button is-secondary"
        >
            Choisir une {{ type === SIM_TYPES.QRESIM ? 'SIM physique' : 'eSIM' }}
        </button>
        <button
            data-tc-action="Clic_selection"
            attr.data-tc-categorie="{{
                type === SIM_TYPES.QRESIM ? 'Modale_incompatibilite_eSIM' : 'Modale_incompatibilite_carte_SIM'
            }} "
            attr.data-tc-clic="{{ type === SIM_TYPES.QRESIM ? 'Conserver_ma_eSIM' : 'Conserver_ma_carte_SIM' }}"
            (click)="confirmChoice(true)"
            class="button is-primary"
        >
            Choisir une {{ type === SIM_TYPES.QRESIM ? 'eSIM' : 'SIM physique' }}
        </button>
    </div>
</ng-template>
